DialogController = App.loadClass 'core::Angular/DialogController'

class exports.EditCompanyPagesController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @service, @company, pages, reports) ->
        super @scope, @transitions, @modalInstance

        @scope.absolute_errors = true
        @scope.title = "Edit #{@company.name} Portal Pages and Reports"

        @scope.pages = pages.data
        @scope.reports = reports.data
        @scope.toggleEnabled = @toggleEnabled

    toggleEnabled: (item) =>
        item.enabled = not item.enabled

    save: () =>
        @service.saveCompanyPagesAndReports(
            @company.id
            @scope.pages
            @scope.reports
        ).then (response) =>
            @closeWithAlert(response.data.status)
